//#region IMPORT
import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import MeetingList from '../ui/MeetingList';
//#endregion

function M_MET_BASIC(props) {
  const handleChange = (e, newValue) => {
    props.setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 탭 영역 - 고정 */}
      <Box sx={{ flexShrink: 0 }}>
        <Tabs
          value={props.value}
          onChange={handleChange}
          variant="fullWidth"
          TabIndicatorProps={{
            style: { backgroundColor: '#6c63e9ff', height: 3 },
          }}
          centered
        >
          <Tab
            label="안전보건 협의체"
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              '&.Mui-selected': {
                color: '#6c63e9ff',
              },
            }}
          />
          <Tab
            label="산업안전보건위원회"
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              '&.Mui-selected': {
                color: '#6c63e9ff',
              },
            }}
          />
        </Tabs>
      </Box>

      {/* 리스트 영역 - 스크롤 */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <MeetingList
          rowData={props.value === 0 ? props.rowData1 : props.rowData2}
          tabValue={props.value}
        />
      </Box>
    </Box>
  );
}

export default M_MET_BASIC;
